export default {
    imagesResult: state => {
        return state.imagesResult;
    },
    contentCategory: state => {
        return state.contentCategory;
    },
    contentByCategoryRef: state => {
        return state.contentByCategoryRef;
    },
    contentListByCategoryRef: state => {
        return state.contentListByCategoryRef;
    },
     contentListByCategoryFAQ: state => {
        return state.contentListByCategoryFAQ;
    },
     contentListByCategoryComments: state => {
        return state.contentListByCategoryComments;
    },
     contentListByCategoryArticles: state => {
        return state.contentListByCategoryArticles;
    },
}